"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBannerNotificationWrapper = exports.StyledBannerContentBox = exports.StyledBannerNotificationDescription = exports.StyledBannerNotificationTitle = exports.StyledDotBox = exports.StyledDot = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const general_1 = require("../../general");
exports.StyledDot = styled_components_1.default.div `
  width: ${theme_1.spacings.s2};
  height: ${theme_1.spacings.s2};
  border-radius: ${theme_1.spacings.s2};
  background-color: ${theme_1.system.error};
`;
exports.StyledDotBox = (0, styled_components_1.default)(general_1.Flexbox) `
  height: ${theme_1.spacings.s6};
  border-radius: ${theme_1.spacings.s2};
  padding: ${theme_1.spacings.s2} 0;
  gap: ${theme_1.spacings.s2};
`;
exports.StyledBannerNotificationTitle = (0, styled_components_1.default)(general_1.Typography) `
  font-style: normal;
  font-weight: 600;
  line-height: ${theme_1.spacings.s6};
  color: ${theme_1.primary.darker};
`;
exports.StyledBannerNotificationDescription = (0, styled_components_1.default)(general_1.Typography) `
  font-style: normal;
  font-weight: 500;
  line-height: ${theme_1.spacings.s5};
  color: ${theme_1.grayScale[600]};
`;
exports.StyledBannerContentBox = (0, styled_components_1.default)(general_1.Flexbox) `
  gap: ${theme_1.spacings.s1};
`;
exports.StyledBannerNotificationWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ customStyles }) => {
    return (0, styled_components_1.css) `
      min-height: ${(0, utils_1.pxToRem)(96)};
      width: 100%;
      padding: ${theme_1.spacings.s6};
      gap: ${theme_1.spacings.s2};
      border-radius: ${theme_1.spacings.s2};
      background-color: ${theme_1.grayScale[50]};
      box-shadow: ${theme_1.shadows.default(theme_1.grayScale[900])};

      ${customStyles || {}}
    `;
}}
`;
//# sourceMappingURL=styles.js.map